import { Component, inject, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomModal } from '../../../shared/services/ziro-modal.service';
import { SafeResourceUrl, SafeStyle } from '@angular/platform-browser';
import { ZiroIcons } from '../../../shared/models/ziro-icons.enum';
import { TranslateService } from '@ngx-translate/core';
import { CurrentDateContext } from '../../../shared/contexts/current-date.context';

interface FullPreviewModalViewProperties {
  previewLogo: string | SafeResourceUrl;
  previewBackgroundStyles: SafeStyle;
  loginButtonLabel: string;
  showSupportLink: boolean;
}

@Component({
  selector: 'ziro-admin-customize-ui-full-preview-modal',
  templateUrl: './customize-ui-full-preview-modal.component.html',
  styleUrls: ['./customize-ui-full-preview-modal.component.scss'],
  standalone: false,
})
export class CustomizeUiFullPreviewModalComponent implements CustomModal<FullPreviewModalViewProperties>, OnInit {
  private activeModal = inject(NgbActiveModal);
  private translateService = inject(TranslateService);
  private currentDateContext = inject(CurrentDateContext);

  modalProperties: FullPreviewModalViewProperties;
  ziroIcons = ZiroIcons;
  year: string;
  companyFooterLabel: string;

  ngOnInit(): void {
    this.currentDateContext.state$.subscribe((state) => {
      this.year = String(state.year);
    });
    this.translateService.get('tkey;company.footer').subscribe((translation) => {
      this.companyFooterLabel = translation.replace(/<a[^>]*>(.*?)<\/a>/gi, '$1');
    });
  }

  onCloseClick(): void {
    this.activeModal.close(false);
  }
}
